import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TSubmitOrderRequestSchema,
  TSubmitOrderResponseSchema,
} from "./submitOrder.schema";

export const submitOrder = (axios: IAxiosInstance) => {
  return async (data: TSubmitOrderRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TSubmitOrderResponseSchema>
    >(`/orders/submit`, data);

    return response.data;
  };
};
